import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQueryWithReauth } from '@/services';
import { PaginatedRequest, PaginatedResponse } from '@/types';
import { API_INVENTORY_URL } from '@/utils';
import { UserApi, UsersFilter } from '../models';

const usersService = createApi({
  reducerPath: 'usersService',
  baseQuery: createBaseQueryWithReauth(`${API_INVENTORY_URL}/users`),
  tagTypes: ['Users'],
  endpoints: (builder) => ({
    getUsers: builder.query<
      PaginatedResponse<UserApi>,
      { filters?: UsersFilter; paginated: PaginatedRequest }
    >({
      query: ({ filters, paginated }) => ({
        url: '',
        params: {
          ...(filters || {}),
          limit: paginated.pageSize,
          offset: (paginated.page - 1) * paginated.pageSize,
        },
      }),
      providesTags: ['Users'],
    }),
    createUser: builder.mutation({
      query: (body) => ({
        url: '',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Users'],
    }),
    getUserById: builder.query<UserApi, { userId: string }>({
      query: ({ userId }) => ({
        url: `/${userId}`,
        params: {
          populate: 'assets.assetType,assets.brand,assets.model,assets.office,assets.user',
        },
      }),
      providesTags: ['Users'],
    }),
    updateUser: builder.mutation<UserApi, { userId: string; body: Partial<UserApi> }>({
      query: ({ userId, body }) => ({
        url: `/${userId}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Users'],
    }),
  }),
});

export default usersService;
export const { useGetUsersQuery, useCreateUserMutation, useGetUserByIdQuery, useUpdateUserMutation } =
  usersService;
